import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { filterOptions } from 'utils/methods/helpers';

export const filters = ({
  filterValues,
  minDate,
  users,
  userAssignedDepartments = [],
}) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);
  return {
    RegularFilters: [
      {
        label: 'My Messages Only',
        field: 'myMessagesOnly',
        type: 'toggle',
      },
      {
        label: 'dateFrom',
        field: 'dateFrom',
        type: 'date-picker',
      },
      {
        label: 'dateTo',
        field: 'dateTo',
        type: 'date-picker',
        minDate,
      },
      {
        label: 'sender',
        field: 'senderId',
        type: 'select',
        options: filterOptions({
          options: users,
          filterKey: 'name',
          filterValue: filterValues.id,
        }),
      },
    ],
    AdvancedFilters: [
      ...departmentFilterField,
      {
        label: 'Include Acknowledged',
        field: 'includeAcknowledged',
        type: 'toggle',
      },
      {
        label: 'recipient',
        field: 'recipientId',
        type: 'select',
        options: filterOptions({
          options: users,
          filterKey: 'name',
          filterValue: filterValues.id,
        }),
      },
    ],
  };
};
